import {
  AbstractFeatureChildUIModel,
  AbstractFeatureEntityState,
  AbstractFeatureQueryEntity,
  AbstractFeatureUIModel,
} from '@y42/feature';
import { AbstractGitQueryEntityConfig } from '@y42/feature/git/state';
import { JobbableUIModel } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import { CTypeModel } from '@y42/model';
import { Observable } from 'rxjs';

export abstract class ImpexQuery<
  State extends AbstractFeatureEntityState = AbstractFeatureEntityState,
  UIModel extends AbstractFeatureUIModel = AbstractFeatureUIModel,
  ChildUIModel extends AbstractFeatureChildUIModel = AbstractFeatureChildUIModel & JobbableUIModel,
  ListViewModel extends AbstractFeatureUIModel = AbstractFeatureUIModel,
  TypeModel extends CTypeModel = CTypeModel,
> extends AbstractFeatureQueryEntity<State, UIModel, ChildUIModel, ListViewModel> {
  constructor(
    cfg: AbstractGitQueryEntityConfig<State, UIModel> & {
      featureType: Y42FeatureType;
    },
  ) {
    super(cfg);
  }

  abstract readonly types$: Observable<TypeModel[] | null>;
  abstract readonly active$: Observable<(UIModel & { typeModel: TypeModel }) | undefined>;
  abstract readonly items$: Observable<Array<UIModel & { typeModel: TypeModel }>>;
  abstract toListViewModel(item: UIModel | ChildUIModel): ListViewModel[];
}
